export default __webpack_public_path__ + "static/media/firstStep.d8cd1170.webp";